import React from "react";

import { TableHeaderFilters } from "./table-header/table-header-filters";
import { TableMainContent } from "./table-main-content";
import { useTableColumns } from "../../../../hooks";
import { TableColumn } from "../../../../models";
import { TableHeader } from "./table-header";
import { TableFooter } from "./table-footer";
import { noop } from "../../../../constants";

interface TableProps {
  page: number;
  title?: string;
  count: number;
  rowKey?: string;
  loading?: boolean;
  rows: Array<any>;
  className?: string;
  hasFooter?: boolean;
  rowClicked?: boolean;
  rowClickedKey?: string;
  selectorValue: number;
  filters?: React.ReactNode;
  isDrawPrintIcon?: boolean;
  hideColumnHeaders?: boolean;
  columns: Array<TableColumn>;
  headerActions?: React.ReactNode;
  openJackpotStream?: (row: any) => void;
  onRowClick?: (row: any, index: number) => void;
  onPaginationChange: (page: number, selectorValue: number) => void;
}

export const Table: React.FC<TableProps> = ({
  rows,
  page,
  count,
  filters,
  columns,
  title = "",
  headerActions,
  selectorValue,
  rowKey = "id",
  loading = false,
  className = "",
  isDrawPrintIcon,
  hasFooter = true,
  onRowClick = noop,
  openJackpotStream,
  onPaginationChange,
  rowClicked = false,
  rowClickedKey = "",
  hideColumnHeaders = false,
}) => {
  const { cols } = useTableColumns(columns);
  const countPage = Math.ceil(count / selectorValue);

  return (
    <div className={`main-structure-wrapper ${className}`}>
      <div className="main-structure-top-wrapper">
        {
          headerActions && <TableHeader title={title} actions={headerActions} />
        }
        {
          filters && <TableHeaderFilters filters={filters} />
        }
      </div>
      <TableMainContent
        rows={rows}
        columns={cols}
        rowKey={rowKey}
        loading={loading}
        rowClicked={rowClicked}
        onRowClick={onRowClick}
        rowClickedKey={rowClickedKey}
        isDrawPrintIcon={isDrawPrintIcon}
        hideColumnHeaders={hideColumnHeaders}
        openJackpotStream={openJackpotStream}
      />
      {
        hasFooter && (
          <TableFooter
            count={countPage}
            currentPage={page}
            selectorValue={selectorValue}
            onPaginationChange={onPaginationChange}
          />
        )
      }
    </div>
  );
};
